import './List.scss';
import * as React from 'react';

const List = () => {
  return (
    <div className="benefits-items">
      <div className="item order-1">
        We turned the film characters into collectible, interactive NFT - with a lot of surprises to unfold!
      </div>
      <div className="item order-2">
        Proceeds go to making the feature film: “The Last Assistant” WITH JASON AND PAIGE
      </div>
      <div className="item order-3">
        The NFT owners will have exclusive access to
        <ul>
          <li>UNIQUE PRIZES FROM THE FILMMAKERS AND PERSONALIZED GIFTS</li>
          <li>BEHIND THE SCENES ON THE DEVELOPMENT AND PRODUCTION AS ITS UNFOLDING</li>
          <li>ACCESS TO UNIQUE FOOTAGE AND FUTURE COLLECTABLES FROM THE NEXT FILM</li>
        </ul>
      </div>
      {/*<div className="item order-4">*/}
      {/*  The more you play or trade, the more rare your NFTs become as they will merge in your wallets. Some might be burned in the battle between Heroes & Villains. Stay tuned to find out more!*/}
      {/*</div>*/}
    </div>
  );
}

export default List;
